import React, {useEffect, useState} from 'react';
import messageicon from "../../assets/images/messageicon.svg";
import {Table} from "reactstrap";
import axios from "axios";
import moment from "moment/moment";
import Pagination from "../Pagination";
import TableSkeleton from "../Skeleton/DashboardTableSkeleton";
import NoDataIndicator from "../NoDataIndicator";
import localized from "../../i18n";
import {BiLinkExternal} from "react-icons/bi";

const InvoicesTable = () => {
    const [invoices, setInvoices] = useState([]);
    const [isLoadingInvoices,setLoadingInvoices] = useState(false);

    let initialized = false
    useEffect(() => {
        if (!initialized) {
            initialized = true;
            getInvoices();
        }
    }, []);

    const getInvoices = (page = 1) => {
        setLoadingInvoices(true);
        axios.get(`/api/billings?sort=date:desc&page=${page}`)
            .then((response) => {
                setLoadingInvoices(false);
                setInvoices(response.data.data);
            }).catch((err) => {
                setLoadingInvoices(false);
            })
    }

    const singleEmail = (value) =>{
        axios.post("/api/verify/email",value)
            .then((result)=>{

            }).catch((err)=>{

        })
    }


    return (
        <div className="DashboardTable-main">
            <div className="d-flex justify-content-between align-items-center">
                <div className="DashboardTable-heading">
                    <div><img src={messageicon} alt=""/></div>
                    <h2 className="mb-0">{localized.your_transactions}</h2>
                </div>
            </div>
            <div className="DashboardTable-container">
                <Table borderless={true} responsive={true}>
                    <thead>
                    <tr>
                        <th>No.</th>
                        <th>{localized.No_of_credit}</th>
                        <th>{localized.credit_price}</th>
                        <th>{localized.credit_date}</th>
                        <th>{localized.Invoice}</th>
                    </tr>
                    </thead>
                    <tbody>
                        {isLoadingInvoices && <TableSkeleton/>}
                        {!isLoadingInvoices && (invoices.data || []).length === 0 && <NoDataIndicator/>}
                        {!isLoadingInvoices && ((invoices.data || []).map((item, index) => (
                            <tr key={index}>
                                <td>{index+invoices.from}</td>
                                <td>{item.no_of_credit || "0"}</td>
                                <td>{item.price + '€'|| ""}</td>
                                <td>{item.date ? moment(item.date).format("ll") : ""}</td>
                                <td>{item.receipt_url ? <a href={item.receipt_url} target='_blank'><BiLinkExternal fontSize={25}/></a>: "-" }</td>
                            </tr>
                        )))}
                    </tbody>
                </Table>
                {!isLoadingInvoices && (invoices.data || []).length !== 0 && (
                    <Pagination
                        page={invoices.current_page -1}
                        pages={invoices.last_page}
                        canPrevious={true}
                        canNext={true}
                        onPageChange={(page) => getInvoices(page + 1)}
                    />
                )}
            </div>
        </div>
    );
};

export default InvoicesTable;